var S = /* @__PURE__ */ function(R) {
  return R.CORE_FUNCTIONALITY = "1", R.SITE_IMPROVEMENT = "2", R.ADVERTISING = "3", R;
}({}), L = /* @__PURE__ */ function(R) {
  return R.BANNER_INIT = "BANNER_INIT", R.BANNER_FIRST_RENDER = "BANNER_FIRST_RENDER", R.BANNER_NOT_DISPLAYED = "BANNER_NOT_DISPLAYED", R.SET_COOKIE_PERMISSIONS = "SET_COOKIE_PERMISSIONS", R.OPEN_COOKIE_MODAL = "OPEN_COOKIE_MODAL", R.ACCEPT_ALL_COOKIES = "ACCEPT_ALL_COOKIES", R.REJECT_ALL_COOKIES = "REJECT_ALL_COOKIES", R.ERROR = "ERROR", R;
}({});
export {
  L as COOKIE_MANAGEMENT_EVENT_ACTION,
  S as COOKIE_PERMISSION
};
